import Page from "src/components/layouts/Page";
// import { useTheme } from "src/utils/ThemeProvider";
// import ThemeSelector from "src/components/molecules/ThemeSelector";
import Button from "src/components/atoms/Button";
import css from "./Settings.module.scss";

export default function Settings(params) {
    // const { theme } = useTheme();
    return (
        <Page>
            <div className={css["page"]}>
                {/* <p>{theme === "dark" ? "🌜" : "🌝"}</p> */}

               {/* <h2>Theme</h2> */}
                {/* <ThemeSelector /> */}

                <div className={css["buttons"]}>
                    <Button
                        href="/terms-of-service"
                        label="Terms Of Service"
                        color="gray"
                        variant="secondary"
                    />
                    <Button
                        href="/privacy-policy"
                        label="Privacy Policy"
                        color="gray"
                        variant="secondary"
                    />
                </div>
            </div>
        </Page>
    );
}
